import React from 'react';
import { SingleSignOnController } from './SingleSignOn.Controller';

function SingleSignOn() {
  const { Action } = SingleSignOnController();
  return <div></div>;
}

export { SingleSignOn };
